// extracted by mini-css-extract-plugin
export var container = "_65-0";
export var error = "_65-9";
export var label = "_65-5";
export var light = "_65-6";
export var md = "_65-3";
export var sm = "_65-2";
export var thin = "_65-8";
export var thinBold = "_65-7";
export var vertical = "_65-4";
export var xs = "_65-1";